// [ss-theme-extend] redefine refreshCartDependentContent to replace the whole cart
theme.CartTemplateSection.functions.refreshCartDependentContent = function () {
  const _this = theme.CartTemplateSection
  if (_this.cartRefreshXhr) {
    _this.cartRefreshXhr.abort()
  }

  // fetch new html for the page
  _this.cartRefreshXhr = $.ajax({
    type: 'GET',
    url: theme.routes.cart_url + '?view=ajax',
    success: function (data) {
      var toReplace = ['[data-section-type="cart-template"]'] // [ss-theme-extend] this will replace the whole cart
      var $newDom = $('<div>' + data + '</div>')

      // remove any transitions
      $newDom.find('.fade-in').removeClass('fade-in')
      $newDom.find('[data-cc-animate]').removeAttr('data-cc-animate')

      for (var i = 0; i < toReplace.length; i++) {
        _this.replacingContent = true // to avoid triggering change events when focus is lifted before DOM replacement

        $(toReplace[i]).html($newDom.find(toReplace[i]).html())
        _this.replacingContent = false
      }
    }.bind(_this),
    error: function error(data) {
      if (data.statusText != 'abort') {
        console.log('Error refreshing page')
        console.log(data)
      }
    },
    complete: function () {
      _this.cartRefreshXhr = null
    }.bind(_this),
  })
}

theme.Custom = new function() {
  this.functions = {
    openSidebar: () => {
      const sidebar = $('#sidebar-cart')
      const sidebarOverlay = $('#sidebar-cart-overlay')

      sidebar.on('click', '.continue-shopping', (e) => {
        e.preventDefault()
        this.functions.closeSidebar()
      })
      window.addEventListener('click', this.functions.closeOnOutsideClick)

      $('body').css('overflow', 'hidden')

      sidebar.css('display', 'block').css('right', -sidebar.outerWidth()).stop().animate(
        {
          right: 0,
        },
        {
          duration: 500,
          step: function( now, fx ) {
            sidebar.find('.checkout-subtotal-container').hide().show(0)
          }
        },
        () => {
          sidebar.find('.checkout-subtotal-container').hide().show(0)
        }
      )
      sidebarOverlay.css('pointer-events', 'all').stop().animate(
        {
          opacity: 1,
        },
        500
      )
    },

    closeSidebar: () => {
      const sidebar = $('#sidebar-cart')
      const sidebarOverlay = $('#sidebar-cart-overlay')

      window.removeEventListener('click', this.functions.closeOnOutsideClick)

      $('body').css('overflow', 'auto')
      sidebar.stop().animate(
        {
          right: -sidebar.outerWidth(),
        },
        {
          duration: 500,
          step: function( now, fx ) {
            sidebar.find('.checkout-subtotal-container').hide().show(0)
          }
        },
        () => {
          sidebar.css('display', 'none')
          sidebar.find('.checkout-subtotal-container').hide().show(0)
        }
      )
      sidebarOverlay.css('pointer-events', 'none').stop().animate(
        {
          opacity: 0,
        },
        500
      )
      return false
    },

    closeOnOutsideClick: (e) => {
      if (!e.target.closest('#sidebar-cart')) {
        this.functions.closeSidebar()
      }
    },

    addToCart: async ($form) => {
      const shopifyAjaxAddURL = theme.routes.cart_add_url + '.js'
      const shopifyAjaxCartURL = theme.routes.cart_url + '.js'

      $form
        .find('button[type="submit"]')
        .attr('disabled', 'disabled')
        .each(function () {
          $(this).data('previous-value', $(this).val())
        })
        .val(theme.strings.products_product_adding_to_cart) //Hide any existing notifications

       
      $.post(
        shopifyAjaxAddURL,
        $form.serialize(),
        function (itemData) {
          document.documentElement.dispatchEvent(
            new CustomEvent('theme:cartchanged', {
              bubbles: true,
              cancelable: false,
            })
          )

          //Enable add button
          $form
            .find('button[type="submit"]')
            .removeAttr('disabled')
            .each(function () {
              $btn = $(this) //Set to 'DONE', alter button style, wait a few secs, revert to normal

              $btn.val(theme.strings.products_product_added_to_cart).addClass('inverted')
              window.setTimeout(function () {
                $btn.removeClass('inverted').val($btn.data('previous-value'))
              }, 3000)
            })

          try {

            //Getting the quatity of the added product from the Form            
            const quantity = $form.serializeArray()[3].value;
            //Getting the rest of the product data from itemData            
            const data = JSON.parse(itemData)
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
              event: "add_to_cart",
              ecommerce: {
                currency: 'EUR',
                value: data?.price * 0.01 * quantity ?? 0,
                items: [
                {
                  item_id: (data?.product_id).toString() ?? '',
                  item_name: data?.product_title ?? '',
                  affiliation: data?.vendor ?? '',
                  currency: 'EUR',
                  discount: data?.discounts ?? 0,
                  item_category: data?.product_type ?? '',
                  item_variant: data?.variant_title ?? '',
                  price: data?.price * 0.01 ?? 0,
                  quantity: quantity ?? 0
                }
                ]
              }
            });
          } catch(e) {
            console.error(e)
          }
          $.ajax({
            url: '/cart?view=sidebar-cart',
            dataType: 'HTML',
            method: "GET",
            success: function (htmlData) {
                let data_replace = $(htmlData).find('#data').html();
                $('#data').html(data_replace);
                $(".cart-summary-overlay").addClass("side-cart-open").show();
                $('#sidebar-cart-overlay').css({'opacity':"1","pointer-events":"none"})
                $('body').css('overflow',"hidden"); 
                $.get("/browsing_context_suggestions.json", function(data) {
                  let userCountry = data.detected_values.country.handle;
                  console.log("user country",userCountry);
                  getCartDrawerBottomHeight();
                  if(userCountry == 'NL' || userCountry == 'LU'|| userCountry == 'BE'){
                    $('.gk-sidebar-header').show();
                  }else{
                    $('.gk-sidebar-body').css('padding-top','15px');
                  }
              });
              if(typeof window.recomHandleIntersection == 'function') window.recomHandleIntersection()
            }
        });
          // theme.Custom.functions.openSidebar()
        },
        'text'
      ).fail(function (data) {
        //Enable add button
        $form
          .find('button[type="submit"]')
          .removeAttr('disabled')
          .each(function () {
            $(this).val($(this).data('previous-value'))
          }) //Not added, show message

        if (typeof data != 'undefined' && typeof data.status != 'undefined') {
          var jsonRes = $.parseJSON(data.responseText)
          theme.showQuickPopup(jsonRes.description, $form.find('button[type="submit"]:first'))
        } else {
          //Some unknown error? Disable ajax and add the old-fashioned way.
          $form.attr('ajax-add-to-cart', 'false').submit()
        }
      })
    },
  }
}

theme.applyAjaxToProductForm = function ($formContainer) {
  if (theme.settings.cart_type === 'drawer') {
    $formContainer
      .filter('[data-ajax-add-to-cart="true"]')
      .find('form.product-purchase-form')
      .each(function () {
        $(this).on('submit', function (evt) {
          evt.preventDefault()
          var $form = $(this)
          theme.Custom.functions.addToCart($form)
        })
      })
  }
}
